import { render, staticRenderFns } from "./productCreate.vue?vue&type=template&id=6ae71bb0&scoped=true"
import script from "./productCreate.vue?vue&type=script&lang=js"
export * from "./productCreate.vue?vue&type=script&lang=js"
import style1 from "./productCreate.vue?vue&type=style&index=1&id=6ae71bb0&prod&lang=css"
import style2 from "./productCreate.vue?vue&type=style&index=2&id=6ae71bb0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae71bb0",
  null
  
)

export default component.exports